export const firebaseConfig = {
  apiKey: "AIzaSyDzjpqNC6h9YM6yrZKIsXFReVgnU-B7ANs",
  authDomain: "clapit-app.firebaseapp.com",
  projectId: "clapit-app",
  storageBucket: "clapit-app.firebasestorage.app",
  messagingSenderId: "40178788339",
  appId: "1:40178788339:web:af93ca96d8244e32c59486",
  measurementId: "G-4BMZTR1G47",
};
